import { BigDecimal } from "@pcgerente-node/pcg-comun"
import { logistica_GUIA_PROFORMA } from "@pcgerente-node/pcg-comun/dist/DTOs"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { getAllCities } from "../../../../redux/actions/actionsCrear"
import { RootState, useAppDispatch } from "../../../../redux/store"
import style from "../../../../styles/paged.module.css"
import Loading from "../../../helpers/Loading/Loading"
import { StyleProps4, StyleProps5 } from "../stylesCrearResumenGuia"


interface ChildProps {
    guiasProforma: logistica_GUIA_PROFORMA[];
    guiasSeleccionadas: logistica_GUIA_PROFORMA[];
    handleSeleccionarGuia: (details: logistica_GUIA_PROFORMA) => void
    seleccionarTodasLasGuias: () => void
    camposSeleccionados: ("Numero de bultos" | "Numero de Kg")[]
}


const Paged: React.FC<ChildProps> = ({ guiasProforma,guiasSeleccionadas, handleSeleccionarGuia, seleccionarTodasLasGuias, camposSeleccionados }) => {
    let pages: number[] = []; // el número de páginas de mi componente

    useEffect(() => {
        current(1)
    }, [])

    //Paginado
    //states
    const [actualPage, setActualPage] = useState(1);
    const contenidoPorPágina = guiasProforma.length; //deshabilitamos el paginado en esta línea

    //función recorredora del paginado
    const current = (numberpage: number) => {
        setActualPage(numberpage);
    };

    if (guiasProforma.length > 0) {
        for (let i = 1; i <= Math.ceil(guiasProforma.length / contenidoPorPágina); i++) {
            pages.push(i);
        }
    }

    //logica de recorrido del páginado
    const slicedPaged = () => {
        if (actualPage <= 3) {
            const slice = pages.slice(0, 7);
            return slice;
        }
        if (actualPage > 3 && pages[actualPage + 3] !== undefined) {
            const slice = pages.slice(actualPage - 4, actualPage + 3);
            return slice;
        } else if (actualPage > 3 && pages[actualPage + 4] === undefined) {
            const slice = pages.slice(pages.length - 7, pages.length);
            return slice;
        }
        return [1]
    };

    //acá seleccionamos el contenido general en 15 y lo guardamos en un estado  
    const indexOfLastProduct = actualPage * contenidoPorPágina;
    const indexOfFirstProduct = indexOfLastProduct - contenidoPorPágina;
    const contenidoSliced = guiasProforma.slice(indexOfFirstProduct, indexOfLastProduct);


    //para no sobrecargar con información el get de las bases de datos, nos traemos las ciudades de redux y con eso 
    //empezamos a relacionar los nombres


    const ciudadesStore = useSelector((state: RootState) => state.crear.ciudadesCrear)
    const dispatch = useAppDispatch()

    useEffect(() =>{
        dispatch(getAllCities())
  }, [dispatch])

    return (
        //si hay contenido aparece
        ciudadesStore.info.length>0 ?
        <>
            {guiasProforma.length>0?
            <table id="tablaBlock" className={`table table-responsive`} >
                <thead style={StyleProps4} id="encabezado-tabla-resumen">
                    <tr>
                        <th>
                            <div className="form-check">
                                <input 
                                className="form-check-input" 
                                type="checkbox" 
                                id="inlineFormCheck" 
                                checked={guiasSeleccionadas.length === guiasProforma.length }
                                onChange={() => seleccionarTodasLasGuias()}
                                />
                                <label className="form-check-label" htmlFor="inlineFormCheck"> </label>
                            </div>
                        </th>

                        {/* <th style={StyleProps5}>Doc</th> */}
                        <th style={StyleProps5}>Numero</th> 
                        <th style={StyleProps5}>F.Emision</th>
                        <th style={StyleProps5}>Origen</th>
                        <th style={StyleProps5}>Destino</th>
                        <th style={StyleProps5}>No.</th>
                        <th style={StyleProps5}>Remitente</th>
                        <th style={StyleProps5}>Destinatario</th>
                        {camposSeleccionados.includes("Numero de bultos")?
                            <th style={StyleProps5}>Bultos</th>
                            :<></>
                        }

                        {camposSeleccionados.includes("Numero de Kg")?
                            <th style={StyleProps5}>kg</th>
                            :<></>
                        }

                    </tr>
                </thead>
                <tbody >
                    {contenidoSliced.map((guia, i) => <tr key={i}>
                            <td>
                                <div className="form-check">
                                    <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    id="inlineFormCheck" 
                                    checked={guiasSeleccionadas.includes(guia)}
                                    onChange={() => handleSeleccionarGuia(guia)}
                                    />
                                    <label className="form-check-label" htmlFor="inlineFormCheck"> </label>
                                </div>
                            </td>
                            {/* <td>Prof</td> */}
                                <td >
                                    <Link to={`/home/crear/imprimir/${guia.serie1}-${guia.serie2}-${guia.numeroDocumento}`}>
                                        {`${guia.serie1}-${guia.serie2}-${guia.numeroDocumento}`}
                                    </Link>
                                </td>
                            <td>{new Date(guia.fechaEmision)?.toLocaleDateString()}</td>
                            <td className="Capitalize">{ciudadesStore.info.filter(ciudad => ciudad.id === guia.idCiudadOrigen)[0].nombre}</td>
                            <td className="Capitalize">{ciudadesStore.info.filter(ciudad => ciudad.id === guia.idCiudadDestino)[0].nombre}</td>
                            <td>{`${guia.serie1}-${guia.serie2}-${guia.numeroDocumento}`}</td>
                            <td>{guia.CLIENTE_REMITENTE?.razonSocial}</td>
                            <td>{guia.CLIENTE_DESTINATARIO?.razonSocial}</td>
                            
                            {camposSeleccionados.includes("Numero de bultos")?
                                <td>{new BigDecimal(guia.bultos).toString()}</td>
                                :<></>
                            }

                            {camposSeleccionados.includes("Numero de Kg")?
                                <td>{guia.peso? new BigDecimal(guia.peso).toString() : "N/A"}</td>
                                :<></>
                            }

                        </tr>
                    )}
                </tbody>

            </table>
            :
            <>
            <table id="default-ordering" className="table table-responsive">
                <thead style={StyleProps4}>
                    <tr>
                        <th>
                            <div className="form-check">
                                <input 
                                type="checkbox" 
                                id="inlineFormCheck" 
                                />
                                <label className="form-check-label" htmlFor="inlineFormCheck"> </label>
                            </div>
                        </th>

                        <th style={StyleProps5}>F.Emision</th>
                        <th style={StyleProps5}>Origen</th>
                        <th style={StyleProps5}>Destino</th>
                        <th style={StyleProps5}>No.</th>
                        <th style={StyleProps5}>Remitente</th>
                        <th style={StyleProps5}>Destinatario</th>
                        {camposSeleccionados.includes("Numero de bultos")?
                            <th style={StyleProps5}>Bultos</th>
                            :<></>
                        }

                        {camposSeleccionados.includes("Numero de Kg")?
                            <th style={StyleProps5}>kg</th>
                            :<></>
                        }
                        {/* <th style={StyleProps5}>Factura</th> */}
                    </tr>
                </thead>
            </table>
            <div className="d-flex justify-content-center">
                <span className="mt-2">No hay guias disponibles</span>
            </div>
            </>
            }

            {
                guiasProforma.length > contenidoPorPágina ?
                    <>
                        <div className={`${style.container}`} id="paginado">
                            <ul className={style.containerPages}>
                                <button className={`${style.button} ${(actualPage === 0 || actualPage === 1) ? style.hiddenButton : style.buttonHover}`} onClick={() => current(actualPage - 1)}>{'<'}</button>
                                {slicedPaged().map(page => {
                                    if (page === actualPage) {
                                        return (
                                            <li onClick={() => current(page)} className={`${style.page} ${style.pageActual}`} key={page} > {page} </li>
                                        )
                                    }
                                    else return (
                                        <li onClick={() => current(page)} className={style.page} key={page}> {page} </li>
                                    )
                                })}
                                <button className={`${style.button} ${(pages[pages.length - 1] <= 1 || actualPage === pages[pages.length - 1] || guiasProforma.length < 1) ? style.hiddenButton : style.buttonHover}`} onClick={() => current(actualPage + 1)}>{">"}</button>
                            </ul>
                        </div>
                    </>
                    :
                    <></>
            }
        </>
        :
        <Loading/>
    )
}



export default Paged